// Thin React wrapper around the shared eim-profile widget (eimProfile.js,
// canonical copy in the eim-auth repo). Shows the signed-in user's name;
// clicking it opens their details + the dashboards they can access.
import { useEffect, useRef } from 'react';
import './eimProfile.js';

export default function ProfileChip({ user = null, currentPortal = null, apiBase = '', onLogout = null, compact = false }) {
  const ref = useRef(null);
  useEffect(() => {
    const w = window.EIMProfile?.mount(ref.current, { user, currentPortal, apiBase, onLogout, compact });
    return () => w?.destroy();
    // mount once — the widget fetches /api/auth/me itself when user is null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <span ref={ref} style={{ display: 'inline-flex' }} />;
}
